import React, { Component } from 'react';

class LoginPage extends Component {
    constructor() {
        super();
        this.state = {
            username: null,
            password: null,
            user: null
        }
    }

    _handleSubmit(e) {
        this.props.login(this.state.username, this.state.password);
        e.preventDefault();
    }

    _handleUsernameInput(e) {
        this.setState({username: e.target.value});
    }

    _handleUuserPasswordInput(e) {
        this.setState({password: e.target.value});
    }

    render() {
        let text = this.state.user !== null ? `Welcome ${this.state.user.name}` : 'Login';

        return (
            <div>
                <form onSubmit={this._handleSubmit.bind(this)}>
                    <h3>Login</h3>
                    <div>
                        <label>Username</label>
                        <input type="text" onChange={this._handleUsernameInput.bind(this)} />
                    </div>
                    <div>
                        <label>Password</label>
                        <input type="password" onChange={this._handleUuserPasswordInput.bind(this)} />
                    </div>
                    <div>
                        <button>Login</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default LoginPage;


// WEBPACK FOOTER //
// src/pages/login/login.page.js